import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tribes-selector" }
const _hoisted_2 = { class: "sub-menu-header" }
const _hoisted_3 = { class: "tribes-type-selector" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "treebal-megaphone-type-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "treebal-chat-rounded-square" }, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "sub-menu-content placeholder-container items selectable"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"item-logo placeholder placeholder-lg col-1\"></div><div class=\"item-name placeholder placeholder-lg col-6\"></div><div class=\"item-info placeholder placeholder-lg col-1\"></div><div class=\"item-actions dropdown dots\"><button class=\"btn btn-neutral dropdown-toggle placeholder\" type=\"button\"></button></div>", 4)
const _hoisted_11 = [
  _hoisted_7
]
const _hoisted_12 = {
  key: 4,
  class: "sub-menu-content"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 5,
  class: "sub-menu-footer"
}
const _hoisted_16 = ["data-bs-target", "disabled"]
const _hoisted_17 = ["data-bs-target", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_provide_feature_decisions = _resolveComponent("provide-feature-decisions")!
  const _component_search_field = _resolveComponent("search-field")!
  const _component_tribes_information_list = _resolveComponent("tribes-information-list")!
  const _component_tribes_discussion_list = _resolveComponent("tribes-discussion-list")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.internalMode)
      ? (_openBlock(), _createBlock(_component_provide_feature_decisions, {
          key: 0,
          features: "tribes-discussions"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: _normalizeClass({ selected: _ctx.isInformation }),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setToTribeInformation && _ctx.setToTribeInformation(...args)))
              }, [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("tribes.types.information")), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass({ selected: _ctx.isDiscussion }),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setToTribeDiscussion && _ctx.setToTribeDiscussion(...args)))
              }, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("tribes.types.discussion")), 1)
              ], 2)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_search_field, {
      placeholder: _ctx.$t(`global.search`),
      search: _ctx.search,
      "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event))
    }, null, 8, ["placeholder", "search"]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
            return _createElementVNode("div", {
              key: index,
              class: "item placeholder-glow"
            }, _hoisted_11)
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isInformation)
      ? (_openBlock(), _createBlock(_component_tribes_information_list, {
          key: 2,
          class: "sub-menu-content"
        }))
      : (_ctx.isDiscussion)
        ? (_openBlock(), _createBlock(_component_provide_feature_decisions, {
            key: 3,
            features: "tribes-discussions"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tribes_discussion_list, { class: "sub-menu-content" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.hasTribes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_ctx.isInformation)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                innerHTML: _ctx.$t('tribes-information.noTribes')
              }, null, 8, _hoisted_13))
            : _createCommentVNode("", true),
          (_ctx.isDiscussion)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                innerHTML: _ctx.$t('tribes-discussion.noTribes')
              }, null, 8, _hoisted_14))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_ctx.$breakpoints.mobile && _ctx.isInformation)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "btn btn-primary",
                disabled: !_ctx.$can('create', 'TribeInformation'),
                to: { name: `${_ctx.modeRouteName}TribeInformationCreate` }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("tribes-information.new")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "to"]))
            : _createCommentVNode("", true),
          (!_ctx.$breakpoints.mobile && _ctx.isInformation)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": `#${_ctx.mode}TribeForm`,
                disabled: !_ctx.$can('create', 'TribeInformation')
              }, _toDisplayString(_ctx.$t("tribes-information.new")), 9, _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.isDiscussion)
            ? (_openBlock(), _createBlock(_component_provide_feature_decisions, {
                key: 2,
                features: "tribes-discussions"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": `#${_ctx.mode}TribeDiscussionCreate`,
                    disabled: !_ctx.$can('create', 'TribeDiscussion')
                  }, _toDisplayString(_ctx.$t("tribes-discussion.new")), 9, _hoisted_17)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}